import { pinNav, getNavHeight } from './pinNav';
import scrollSpyNav from './scrollSpyNav';
import './modelNav.scss';
import './modelSection.scss';
import HashNavigation from './modelHashNavigation';
import * as SharedWidgetPricingService from '../../shared/PricingService/SharedWidgetPricingService';
import $ from 'jquery';

export default function () {
    const MOBILE_LAYOUT = 'Mobile';
    const ANIMATION_TIME = 350;
    const $animationTarget = $('html, body');
    const $nav = $('#model-nav');
    const $accordion = $('#model-accordion');

    let isMobile = (vendor.pageInfo.getLayout() === MOBILE_LAYOUT);
    let activeTabId = $nav.find('.active a').prop('hash');

    HashNavigation();
    requestAnimationFrame(pinNav);

    $(window).on('resize', function () {
        const currentLayout = vendor.pageInfo.getLayout();
        let activeTabId = $nav.find('.active a').prop('hash');

        if (!isMobile && currentLayout === MOBILE_LAYOUT) {
            accordionShowTab(activeTabId);
            isMobile = (currentLayout === MOBILE_LAYOUT);
        } else if (isMobile && currentLayout !== MOBILE_LAYOUT) {
            hashAnimation(activeTabId);
            isMobile = (currentLayout === MOBILE_LAYOUT);
        }
    }).on('cro.products.price-and-shop', onPriceAndShopLoadListener);

    scrollSpyNav();

    //hides login popup's inside modelNav on orientationchange + resize events
    $(window).on('orientationchange resize', () => {
        const $activeIcon = $('.model-nav .subnav-lock-icon-active');
        if ($activeIcon.length) {
            $('#subnav-log-in').hide();
            $activeIcon.removeClass('subnav-lock-icon-active');
        }
    });

    $('.model-section__heading').on('click', function (e) {
        if (!isMobile) {
            e.stopImmediatePropagation();
        }
    });

    $('.model-section__heading:not(".locked-section")').on('click', function (e) {
        const $this = $(this);
        const sectionId = $this.closest('.model-section').attr('id');

        if (isMobile && $this.find('a').hasClass('collapsed')) {
            activeTabId = `#${sectionId}`;
            handleHistoryPush(sectionId);
        }
    });

    $('.model-nav__additional-info__wrapper .model-nav__additional-info__inner-left').on('click', function () {
        $('html, body').animate({
            scrollTop: 0
        }, ANIMATION_TIME);
    });

    function handleHistoryPush(newHash) {
        let hash = location.pathname.replace(/\/$/, '').split('/').splice(-1)[0];
        let newPath = location.pathname.replace(hash, newHash);

        if (newHash !== hash) {
            history.pushState({}, hash, newPath);
        }
    }

    function hashAnimation(hash) {
        if (!hash || $(hash).length) return;

        $animationTarget.animate({
            scrollTop: $(hash).offset().top - getNavHeight()
        }, ANIMATION_TIME);
    }

    function accordionShowTab(activeTabId) {
        $accordion.find('.collapse.in').collapse('hide');

        setTimeout(function () {
            $(activeTabId).find('.collapse').collapse('show');
        }, ANIMATION_TIME);
    }

    function onPriceAndShopLoadListener(event, type, data) {
        const priceContainer = '.model-nav__additional-info__price span';
        const modelSelector = '.price-model';

        if (type === 'loadData-error' || !data) {
            $('#model-nav-links .price-and-shop-link').hide();
            SharedWidgetPricingService.showPrice(priceContainer, modelSelector);
        } else if (type === 'loadData-model') {
            const price = SharedWidgetPricingService.definePriceRange(data);

            const $priceContainer = $('.product-model-price-container .price-model');
            const isDontBuy = !!$priceContainer.data('is-dont-buy');
            (price.minPrice && !isDontBuy) ?
                $(priceContainer).html(price.priceString) :
                SharedWidgetPricingService.showPrice(priceContainer, modelSelector);
        }
    }
}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/ModelNav/index.js